import { hierarchicalMenu } from 'instantsearch.js/es/widgets'

/**
 * Load the Hierarchical Menu widgets.
 *
 * @param {Element} mainContainer The main search container.
 * @returns {Array} The stats widgets.
 */
export default function hierarchicalMenuWidgets( mainContainer ) {
  const widgets = []

  Array.from( mainContainer.querySelectorAll( '.js-instant-search-hierarchical-menu' ) ).forEach(
    element => {
      widgets.push(
        hierarchicalMenu({
          container: element,
          separator: ' > ',
          sortBy: ['count'],
          attributes: JSON.parse( element.dataset.attributes )
        })
      )
    })

  return widgets
}
